module.exports = __webpack_public_path__ + "static/kv-map-7606319270ee80ffa5ae8ac6b85c18f5.png";